<template>
  <div class="popover-content">
    <el-tabs v-model="activeKey" class="tabs">
      <el-tab-pane v-for="item in tabs" :label="item.label" :name="item.value" :key="item.value"></el-tab-pane>
    </el-tabs>
    <div class="luggage-content" v-if="showLuggage">
      <div class="title-row" v-if="showLuggage && showRefund">
        <span class="pop-t-gap"></span>
        行李规定
      </div>
      <RefundLuggage v-if="currentLuggageRule && currentLuggageRule.length" :luggages="currentLuggageRule" />
      <div class="no-desc" v-else>暂无行李规定</div>
    </div>

    <div class="refund-content" v-if="showRefund">
      <div class="title-row" v-if="showLuggage && showRefund">
        <span class="pop-t-gap"></span>
        退改签规则
      </div>
      <el-table class="table" border :data="currentRefundRule" v-if="currentRefundRule && currentRefundRule.length">
        <el-table-column width="200" label="变更时段" prop="operateLabel">
          <template slot-scope="scope">
            <div>{{ scope.row.operateLabel }}</div>
          </template>
        </el-table-column>
        <el-table-column label="退票收费" prop="refundFee">
          <template slot-scope="scope">
            <div>{{ scope.row.refundAllowed ? `￥${scope.row.refundFee}/人` : '以航司客规为准' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="改期收费" prop="changeFee">
          <template slot-scope="scope">
            <div>{{ scope.row.changeAllowed ? `￥${scope.row.changeFee}/人` : '以航司客规为准' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="签转">
          <template slot-scope="scope">
            <div>{{ scope.row.allowEndorse ? '允许签转' : '不允许签转' }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="no-desc" v-else>退改以航司客规为准</div>
    </div>
    <div class="refund-tips" style="line-height: 25px" v-html="refundTips"></div>
  </div>
</template>

<script>
import RefundLuggage from "./RefundLuggage";
export default {
  components: { RefundLuggage },

  props: {
    tabs: {
      type: Array,
      default: () => [
        { label: "成人", value: "ADT", luggageField: "adtBaggageRule", refundField: "adtRefundChangeRule" },
        { label: "儿童", value: "CHD", luggageField: "chdBaggageRule", refundField: "chdRefundChangeRule" }
      ]
    },
    dataItem: {
      type: Object,
      default: () => ({})
    },
    showLuggage: {
      type: Boolean,
      default: true
    },
    showRefund: {
      type: Boolean,
      default: true
    },
    refundTips: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      activeKey: "",
    };
  },
  mounted() {
  },

  computed: {
    currentTabItem() {
      return this.tabs.find(item => item.value == this.activeKey) || this.tabs[0];
    },
    currentLuggageRule() {
      return this.showLuggage && this.dataItem?.[this.currentTabItem.luggageField] || [];
    },
    currentRefundRule() {
      return this.showRefund && this.dataItem?.[this.currentTabItem.refundField] || [];
    }
  },

  methods: {
    setTabsDefault(key) {
      if(key !== undefined && key !== null && key !== '') {
        this.activeKey = key;
      } else {
        this.activeKey = this.tabs.length ? (this.tabs[0] && this.tabs[0].value || "") : ""
      }
    },
  }
};
</script>

<style lang="less" scoped>
.popover-content {
  width: 100%;
  min-width: 600px;
}
.title-row {
  line-height: 40px;
  display: flex;
  align-items: center;
}

.pop-t-gap {
  width: 4px;
  height: 20px;
  background: #d70039;
  margin-right: 5px;
  display: inline-block;
}

.no-desc {
  padding: 10px;
}

.refund-tips {
  margin-top: 10px;
}
.tabs {
  /deep/.el-tabs__header {
    margin-bottom: 6px;
  }
}
</style>
